import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MobileFirstComponent } from './mobile-first.component';
import { UpcomingFeatureModule } from 'ngx-mobile-app';



@NgModule({
  declarations: [
    MobileFirstComponent
  ],
  imports: [
    CommonModule,
    UpcomingFeatureModule,
  ]
})
export class MobileFirstModule { }
